import React, { useState, useEffect, useRef } from 'react';

import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import './PhotoCrop.css';

import { SetModalData, SetModalState, RegisterModalData, RegisterModalObserver } from 'interface/PopUp.js';
import { SvgClose } from 'components/SvgFile';

export default function PopUp_PhotoCrop(){

    const positionImg = useRef();
    
    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    const [ typeCrop, setTypeCrop ]   = useState(3);

    const [ proportionX, setProportionX ] = useState(9);
    const [ proportionY, setProportionY ] = useState(16);

    const [ crop, setCrop ] = useState({
        unit: '%', // Can be 'px' or '%'
        aspect: proportionX / proportionY,
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });

    useEffect(()=>{
        RegisterModalData('Crop', setModaldata);
        RegisterModalObserver('Crop', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp == true){
            if(modalData.origin == "services"){
                setTypeCrop(modalData.crop);
                switch (modalData.crop) {
                    case 1:
                            setProportionX(16);
                            setProportionY(16);
                        break;
                    case 2:
                            setProportionX(16);
                            setProportionY(9);
                        break;
                    case 3:
                            setProportionX(9);
                            setProportionY(16);
                        break;
                }
            }else if(modalData.origin != "portfolio"){
                setProportionX(16);
                setProportionY(9);
                setTypeCrop(2);
            }
        }
    }, [showPopUp]);

    async function cropImageNow (){
        modalData.RegisterCropData(
            { 
                "type"      : modalData.origin,
                "typeInput"      : modalData.type,
                "index"     : modalData.index, 
                "index_1"   : modalData.index_1,
                "upload"    : true,
                "file"      : modalData.file, 
                "showImg"   : modalData.showImg, 
                "positionX" : crop.x, 
                "positionY" : crop.y, 
                "width"     : crop.width, 
                "height"    : crop.height,
                "typeCrop"  : typeCrop,
                "showWidth" : positionImg.current.clientWidth,
                "widthReal" : positionImg.current.naturalWidth
            }
        );
        setTypeCrop(3);
        SetModalState('PhotoCrop', false);
    };
 
    // Starts cropping at 9/16 ratio centered on image
    function onImageLoad(e) {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
        let crop = "";
        modalData.origin == "portfolio" || modalData.origin == "services" ?
        crop = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 90,
                }
            ),
            width,
            height
        ) :
        crop = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 90,
                }
            ),
            width,
            height
        )  
        setCrop(crop);
    }

    function ClosePopUp(){
        setTypeCrop(3);
        SetModalState('Crop', false);
    }

    return (
        (showPopUp ? 
            <div className="PopUp">
                <div className="all photo_crop">
                    <div className="div_data type_div">
                        <div className="title">Recorte de foto</div>
                        <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                            <SvgClose color="#F00000" className="icons" />
                        </div>
                    </div>
                    <div className="div_data" style={ { paddingTop: 0 } }>
                        <div className="content">
                            {
                                modalData.origin == "cover" || modalData.origin == "services" ?
                                    crop.width > 0 ? 
                                    <div className="new_block_text" onClick={ ()=>{ cropImageNow() } }>Salvar</div> :
                                    <div className="new_block_text">É necessário recortar a imagem para salvar</div>
                                    :
                                        typeCrop == 3 ? 
                                        <div className="new_block_text" onClick={ ()=>{ cropImageNow() } }>Salvar</div>
                                        :
                                        crop.width > 0 ?
                                        <div className="new_block_text" onClick={ ()=>{ cropImageNow() } }>Salvar</div>:
                                        <div className="new_block_text">É necessário recortar a imagem para salvar</div>
                            }
                            <div className="">Clique na imagem e arrasta para realizar o recorte</div>
                            <div className="image_crop">
                                { 
                                    modalData.origin == "portfolio" ? 
                                    <div className="type_crop">
                                        <div className={ typeCrop == 3 ? "crop_img crop_img_active" : "crop_img" } onClick={ ()=>{ setTypeCrop(3); } }>
                                            Sem recorte
                                        </div>
                                        <div className={ typeCrop == 1 ? "crop_img crop_img_active" : "crop_img" } onClick={ ()=>{ setTypeCrop(1); setProportionX(16); setProportionY(9); } }>
                                            Recorte na horizontal
                                        </div>
                                        <div className={ typeCrop == 2 ? "crop_img crop_img_active" : "crop_img" } onClick={ ()=>{ setTypeCrop(2); setProportionX(9); setProportionY(16); } }>
                                            Recorte na vertical
                                        </div>                                    
                                    </div> : null
                                }
                                {
                                    modalData.origin != "services" ? 
                                        typeCrop == 3 ?
                                        <img ref={ positionImg } src={ modalData.showImg } className="image" /> :
                                        <ReactCrop crop={ crop } onChange={ setCrop } aspect={ proportionX / proportionY }>
                                            <img ref={ positionImg } src={ modalData.showImg } onLoad={ onImageLoad } className="image" />
                                        </ReactCrop> 
                                        :
                                        <ReactCrop crop={ crop } onChange={ setCrop } aspect={ proportionX / proportionY }>
                                            <img ref={ positionImg } src={ modalData.showImg } onLoad={ onImageLoad } className="image" />
                                        </ReactCrop>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div> 
        : <React.Fragment></React.Fragment>)
    );
}